<template>
  <van-popup
    v-model:show="popupVisible"
    position="center"
    :overlay-style="{ backgroundColor: '#00000088' }"
    round
    :style="{ background: '#ffffff00' }"
  >
    <div class="relative rounded-sm">
      <!-- <img :src="qrcodeUrl" alt="二维码" class="h-50 w-50" /> -->
    </div>
  </van-popup>
</template>

<script setup lang="ts">
import QRCode from 'qrcode'
import qrcodeLogo from '@/assets/images/share-logo.jpg'
import { useChannelStore } from '@/stores'

const channelStore = useChannelStore()
const popupVisible = computed({
  get: () => channelStore.qrcodePopupVisible,
  set: (val) => {
    if (val) {
      channelStore.showQrcodePopup()
    } else {
      channelStore.hideQrcodePopup()
    }
  },
})
const qrcodeUrl = ref('')
const loadQrcodeLogoImage = (): Promise<HTMLImageElement> => {
  return new Promise((resolve) => {
    const image = new Image()
    image.src = qrcodeLogo
    image.onload = () => {
      resolve(image)
    }
    if (image.complete) {
      resolve(image)
    }
  })
}
const drawQrcode = async () => {
  const canvas = document.createElement('canvas')
  canvas.width = 720
  canvas.height = 720
  canvas.style.display = 'none'
  document.body.appendChild(canvas)
  const context = canvas.getContext('2d')
  QRCode.toCanvas(canvas, window.location.href, {
    errorCorrectionLevel: 'H',
    margin: 2,
    width: 720,
  })
  const qrocdeLogoImage = await loadQrcodeLogoImage()
  const { naturalHeight, naturalWidth } = qrocdeLogoImage
  context?.drawImage(qrocdeLogoImage, 0, 0, naturalWidth, naturalHeight, 285, 285, 150, 150)
  qrcodeUrl.value = canvas.toDataURL()
  canvas.remove()
}

watch(popupVisible, () => {
  if (popupVisible.value) {
    drawQrcode()
  }
})
</script>
